import { ReactNode } from "react";
import { Loader } from "rizzui";
import LinkNext from "../ui/LinkNext";

type Props = {
  label?: any;
  loading?: boolean;
  type?: any;
  disabled?: boolean;
  className?: any;
  link?: any;
  icon?: any;
  onClick?: (
    e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>,
  ) => void;
  style?: any;
  outline?: boolean;
  leftIcon?: ReactNode;
  labelClassName?: string;
  children?: ReactNode;
};

const CustomButon = ({
  loading = false,
  type = "submit",
  label,
  disabled,
  className,
  link,
  onClick,
  icon,
  style,
  leftIcon,
  labelClassName,
  outline = false,
  children,
}: Props) => {
  const isOnline = true;

  const baseClasses =
    "relative transition duration-200 inline-flex text-[12px] items-center justify-center rounded-sm font-normal cursor-pointer disabled:opacity-70 disabled:cursor-not-allowed px-3 py-2 align-top";
  const filledClasses = "bg-primary text-white";
  const outlineClasses =
    "bg-transparent border border-primary text-primary";
  const finalClass = `${baseClasses} ${
    outline ? outlineClasses : filledClasses
  } ${className || ""}`;

  const renderIcon = () => {
    if (loading) {
      return <Loader size="sm" className="text-white" />;
    }
    return icon ? icon : null;
  };

  const ButtonContent = (
    <>
      {leftIcon && <span className="mr-1.5 sm:mr-2 shrink-0">{leftIcon}</span>}
      {label && !loading && (
        <span className={`${icon ? "mr-1.5 sm:mr-2" : ""} ${labelClassName || ""}`}>{label}</span>
      )}
      {!loading && renderIcon()}

      {/* Skeleton overlay lorsque loading */}
      {loading && <Loader size="sm" className="text-white" />}
    </>
  );

  return link ? (
    <LinkNext
      onClick={(e) => {
        e.stopPropagation();
        if (onClick && isOnline) onClick(e);
      }}
      style={style}
      href={link}
      className={finalClass}
    >
      {ButtonContent}
    </LinkNext>
  ) : (
    <button
      onClick={(e) => {
        e.stopPropagation();
        if (onClick) onClick(e);
      }}
      style={style}
      disabled={!isOnline || disabled || loading}
      type={type}
      className={finalClass}
    >
      {children ?? ButtonContent}
    </button>
  );
};

export default CustomButon;
